export const STAFF_ROLES = ['superadmin', 'admin', 'technician', 'investor', 'noc'];

export const normalizeStaffRole = (rawRole) => {
  const role = String(rawRole || '').trim().toLowerCase();
  if (role === 'admin' || role === 'administrator' || role === 'superadmin') return 'superadmin';
  if (STAFF_ROLES.includes(role)) return role;
  return 'superadmin';
};

export const getStaffHomeRoute = (rawRole) => {
  const role = normalizeStaffRole(rawRole);
  if (role === 'noc') return '/noc';
  if (role === 'technician') return '/teknisi';
  if (role === 'investor') return '/investor';
  return '/dadu';
};

export const getStoredStaffUser = () => {
  try {
    const raw = localStorage.getItem('ktc_user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

const getTokenRole = () => {
  try {
    const token = localStorage.getItem('ktc_token') || localStorage.getItem('access_token');
    if (!token) return '';

    const parts = token.split('.');
    if (parts.length < 2) return '';

    const payloadBase64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = payloadBase64.padEnd(payloadBase64.length + ((4 - (payloadBase64.length % 4)) % 4), '=');
    const payload = JSON.parse(atob(paddedBase64));
    return String(payload?.role || '');
  } catch {
    return '';
  }
};

export const getStoredStaffRole = () => {
  const user = getStoredStaffUser();
  return normalizeStaffRole(user?.role || getTokenRole());
};

